/* ewd-avisame.js . boton Avisame PROPIO de eWheel (Torre 757, 20/10/2026).
   La peticion se guarda en Argos (https://catalogo.ewheel.es/avisame/...), no en la app de Upango.
   - Usa los botones que ya pinta el tema (.avisame-btn-container con variant-id). En una ficha sin ellos pone
     uno junto al formulario de compra, para la variante elegida si esta agotada.
   - El cliente lo dice el token que firma el tema (snippets/ewd-avisame.liquid); sin sesion, los botones se ocultan
     (igual que hacia la app de Upango).
   - Mientras el bloque de Upango (upng-avisame) siga encendido NO HACE NADA: manda el suyo. Apagar ese bloque es
     el cambio; volver a encenderlo es la vuelta atras.
   - "Mis avisos" (F4): cualquier pagina con <div id="ewd-mis-avisos"></div> ensena la lista del cliente. */
(function () {
  'use strict';
  var C = window.ewdAvisameCfg;
  if (!C || window.ewdAvisame) return;

  var SEL = '.avisame-btn-container, .ewd-avisame-btn';
  var TEXTOS = {
    es: { colProducto: 'Producto', colEstado: 'Estado', quitarSel: 'Quitar seleccionados', todosSel: 'Seleccionar todos', descatalogado: 'Descatalogado', verSustituto: 'Descatalogado · Ver sustituto', off: 'Dejar de avisarme', error: 'No se ha podido guardar. Inténtalo de nuevo.', sesion: 'Tu sesión ha caducado. Recarga la página.', titulo: 'Mis avisos', vacio: 'No tienes avisos pendientes.', pendiente: 'Te avisaremos cuando vuelva a haber stock', avisado: 'Avisado el', quitar: 'Quitar', cargando: 'Cargando…', entra: 'Entra en tu cuenta para ver tus avisos.' },
    en: { colProducto: 'Product', colEstado: 'Status', quitarSel: 'Remove selected', todosSel: 'Select all', descatalogado: 'Discontinued', verSustituto: 'Discontinued · See replacement', off: 'Stop notifying me', error: 'Could not be saved. Please try again.', sesion: 'Your session has expired. Please reload the page.', titulo: 'My stock alerts', vacio: 'You have no pending alerts.', pendiente: 'We will let you know when it is back in stock', avisado: 'Notified on', quitar: 'Remove', cargando: 'Loading…', entra: 'Log in to see your alerts.' },
    fr: { colProducto: 'Produit', colEstado: 'Statut', quitarSel: 'Retirer la sélection', todosSel: 'Tout sélectionner', descatalogado: 'Produit arrêté', verSustituto: 'Produit arrêté · Voir le remplaçant', off: 'Ne plus m’avertir', error: 'Impossible d’enregistrer. Veuillez réessayer.', sesion: 'Votre session a expiré. Rechargez la page.', titulo: 'Mes alertes', vacio: 'Vous n’avez aucune alerte en attente.', pendiente: 'Nous vous préviendrons dès le retour en stock', avisado: 'Prévenu le', quitar: 'Retirer', cargando: 'Chargement…', entra: 'Connectez-vous pour voir vos alertes.' },
    it: { colProducto: 'Prodotto', colEstado: 'Stato', quitarSel: 'Rimuovi selezionati', todosSel: 'Seleziona tutti', descatalogado: 'Fuori produzione', verSustituto: 'Fuori produzione · Vedi il sostituto', off: 'Non avvisarmi più', error: 'Impossibile salvare. Riprova.', sesion: 'La sessione è scaduta. Ricarica la pagina.', titulo: 'I miei avvisi', vacio: 'Non hai avvisi in attesa.', pendiente: 'Ti avviseremo quando tornerà disponibile', avisado: 'Avvisato il', quitar: 'Rimuovi', cargando: 'Caricamento…', entra: 'Accedi per vedere i tuoi avvisi.' },
    pt: { colProducto: 'Produto', colEstado: 'Estado', quitarSel: 'Remover selecionados', todosSel: 'Selecionar todos', descatalogado: 'Descontinuado', verSustituto: 'Descontinuado · Ver substituto', off: 'Deixar de avisar-me', error: 'Não foi possível guardar. Tente novamente.', sesion: 'A sua sessão expirou. Recarregue a página.', titulo: 'Os meus avisos', vacio: 'Não tem avisos pendentes.', pendiente: 'Avisamos quando voltar a haver stock', avisado: 'Avisado em', quitar: 'Remover', cargando: 'A carregar…', entra: 'Inicie sessão para ver os seus avisos.' },
    de: { colProducto: 'Artikel', colEstado: 'Status', quitarSel: 'Auswahl entfernen', todosSel: 'Alle auswählen', descatalogado: 'Nicht mehr erhältlich', verSustituto: 'Nicht mehr erhältlich · Ersatz ansehen', off: 'Nicht mehr benachrichtigen', error: 'Speichern nicht möglich. Bitte erneut versuchen.', sesion: 'Ihre Sitzung ist abgelaufen. Bitte Seite neu laden.', titulo: 'Meine Benachrichtigungen', vacio: 'Sie haben keine offenen Benachrichtigungen.', pendiente: 'Wir benachrichtigen Sie, sobald es wieder verfügbar ist', avisado: 'Benachrichtigt am', quitar: 'Entfernen', cargando: 'Wird geladen…', entra: 'Melden Sie sich an, um Ihre Benachrichtigungen zu sehen.' },
    pl: { colProducto: 'Produkt', colEstado: 'Status', quitarSel: 'Usuń zaznaczone', todosSel: 'Zaznacz wszystkie', descatalogado: 'Wycofany', verSustituto: 'Wycofany · Zobacz zamiennik', off: 'Nie powiadamiaj mnie', error: 'Nie udało się zapisać. Spróbuj ponownie.', sesion: 'Sesja wygasła. Odśwież stronę.', titulo: 'Moje powiadomienia', vacio: 'Nie masz oczekujących powiadomień.', pendiente: 'Powiadomimy Cię, gdy produkt wróci', avisado: 'Powiadomiono', quitar: 'Usuń', cargando: 'Ładowanie…', entra: 'Zaloguj się, aby zobaczyć powiadomienia.' }
  };
  var T = TEXTOS[String(C.idioma || 'es').slice(0, 2).toLowerCase()] || TEXTOS.es;
  T.on = C.textoAvisame || 'Avísame';

  var lista = new Set();
  var cargada = false;
  // Torre 757 punto 3: variantes descatalogadas en Argos -> handle del sustituto (o null). Se pregunta una vez por variante.
  var desc = new Map();
  var preguntadas = new Set();

  function upangoManda() { return typeof window.upng_avisame_data !== 'undefined' && !C.forzar; }

  function api(ruta, datos) {
    return fetch(C.api + '/avisame/' + ruta, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      credentials: 'omit',
      body: JSON.stringify(Object.assign({ token: C.token }, datos || {}))
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok || !j.ok) { var e = new Error(j.error || ('HTTP ' + r.status)); e.status = r.status; e.datos = j; throw e; }
        return j;
      });
    });
  }

  function idDe(btn) {
    var raw = btn.getAttribute('variant-id') || btn.getAttribute('data-variant-id') || '';
    var n = String(raw).trim();
    return /^\d{6,20}$/.test(n) ? n : null;
  }

  function etiqueta(btn) {
    var l = btn.querySelector('.upng-notify-me-label');
    if (!l) {
      var texto = (btn.textContent || '').trim();
      btn.textContent = '';
      l = document.createElement('span');
      l.className = 'upng-notify-me-label';
      l.textContent = texto;
      btn.appendChild(l);
    }
    return l;
  }

  function pintar(btn) {
    var id = idDe(btn);
    if (!id) return;
    var l = etiqueta(btn);
    if (!btn.hasAttribute('data-ewd-texto')) btn.setAttribute('data-ewd-texto', (l.textContent || '').trim() || T.on);
    if (btn.hasAttribute('data-ewd-aviso')) return;   // esta ensenando un error un momento
    if (desc.has(id)) {
      var sus = desc.get(id);
      btn.classList.remove('btn-avisame-activo');
      btn.classList.add('ewd-av-descatalogado');
      btn.setAttribute('aria-pressed', 'false');
      if (sus) btn.setAttribute('data-ewd-sustituto', sus); else btn.removeAttribute('data-ewd-sustituto');
      l.textContent = sus ? T.verSustituto : T.descatalogado;
      return;
    }
    var activo = lista.has(id);
    btn.classList.toggle('btn-avisame-activo', activo);
    btn.setAttribute('aria-pressed', activo ? 'true' : 'false');
    l.textContent = activo ? T.off : btn.getAttribute('data-ewd-texto');
  }

  function avisar(btn, texto) {
    var l = etiqueta(btn);
    btn.setAttribute('data-ewd-aviso', '1');
    l.textContent = texto;
    setTimeout(function () { btn.removeAttribute('data-ewd-aviso'); pintar(btn); }, 3500);
  }

  function todos() {
    var bs = document.querySelectorAll(SEL);
    for (var i = 0; i < bs.length; i++) pintar(bs[i]);
  }

  // Ficha sin botones del tema: uno propio para la variante elegida, si esta agotada.
  function varianteElegida() {
    var vs = (C.producto && C.producto.variantes) || [];
    if (!vs.length) return null;
    var f = formularioCompra();
    var inp = f && f.querySelector('[name="id"]');
    var id = String((inp && inp.value) || new URLSearchParams(location.search).get('variant') || '');
    for (var i = 0; i < vs.length; i++) if (String(vs[i].id) === id) return vs[i];
    for (var j = 0; j < vs.length; j++) if (vs[j].d) return vs[j];
    return vs[0];
  }

  // El formulario de compra VISIBLE que lleva la variante (name=id); hay otros ocultos (plazos, etc.).
  function formularioCompra() {
    var fs = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < fs.length; i++) if (fs[i].querySelector('[name="id"]') && fs[i].offsetHeight > 0) return fs[i];
    for (var j = 0; j < fs.length; j++) if (fs[j].querySelector('[name="id"]')) return fs[j];
    return null;
  }

  function inyectar() {
    if (!C.producto || !C.token) return;
    var mio = document.querySelector('.ewd-avisame-btn');
    if (document.querySelector('.avisame-btn-container')) { if (mio) mio.remove(); return; }
    var v = varianteElegida();
    if (!v || v.d) { if (mio) mio.remove(); return; }
    // Debajo de "Elegir opciones" (ventana de variantes del tema) o, si no hay, del formulario de compra.
    var form = document.querySelector('.upng-variants-popup--container') || formularioCompra();
    if (!form) return;
    if (!mio) {
      mio = document.createElement('button');
      mio.type = 'button';
      mio.className = 'ewd-avisame-btn';
      mio.innerHTML = '<span class="upng-notify-me-label"></span><span class="upng-notify-me-spinner" aria-hidden="true"></span>';
      form.insertAdjacentElement('afterend', mio);
    }
    if (mio.getAttribute('variant-id') !== String(v.id)) { mio.setAttribute('variant-id', String(v.id)); mio.removeAttribute('data-ewd-texto'); }
    pintar(mio);
  }

  function alPulsar(ev) {
    var btn = ev.target && ev.target.closest ? ev.target.closest(SEL) : null;
    if (!btn || upangoManda()) return;
    ev.preventDefault();
    ev.stopPropagation();
    if (!C.token) { location.href = '/account/login?return_url=' + encodeURIComponent(location.pathname + location.search); return; }
    var id = idDe(btn);
    if (!id || btn.classList.contains('is-loading')) return;
    if (desc.has(id)) {
      var sus = desc.get(id);
      if (sus) location.href = '/products/' + encodeURIComponent(sus);
      return;
    }
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    api('alternar', { variante: id }).then(function (j) {
      if (j.activo) lista.add(id); else lista.delete(id);
      todos();
    }).catch(function (e) {
      if (e.status === 409 && e.datos && e.datos.descatalogado) { desc.set(id, e.datos.sustituto || null); todos(); return; }
      avisar(btn, e.status === 401 ? T.sesion : T.error);
    }).then(function () {
      btn.classList.remove('is-loading');
      btn.removeAttribute('aria-busy');
    });
  }

  // "Mis avisos" (F4): la lista del cliente, con lo pendiente y lo avisado en los ultimos 30 dias.
  function el(tag, clase, texto) {
    var e = document.createElement(tag);
    if (clase) e.className = clase;
    if (texto != null) e.textContent = texto;
    return e;
  }

  // Nombre e imagen de la ficha: /variants/<id> redirige a la ficha; de ahi el handle y del handle, el producto.
  function datosDe(aviso, celdaNombre, celdaImg) {
    return fetch('/variants/' + aviso.variante, { credentials: 'same-origin' }).then(function (r) {
      var m = /\/products\/([^/?#]+)/.exec(r.url || '');
      if (!m) return;
      return fetch('/products/' + m[1] + '.js').then(function (p) { return p.ok ? p.json() : null; }).then(function (p) {
        if (!p || !p.title) return;
        var v = (p.variants || []).filter(function (x) { return String(x.id) === aviso.variante; })[0];
        var nombre = p.title + (v && v.title && v.title !== 'Default Title' ? ' · ' + v.title : '');
        celdaNombre.textContent = nombre;
        var src = (v && v.featured_image && v.featured_image.src) || p.featured_image;
        if (src) {
          var img = document.createElement('img');
          img.src = String(src).replace(/^\/\//, 'https://') + (String(src).indexOf('?') < 0 ? '?width=120' : '&width=120');
          img.alt = nombre; img.width = 60; img.height = 60; img.loading = 'lazy';
          celdaImg.appendChild(img);
        }
      });
    }).catch(function () { /* se queda con el SKU */ });
  }

  // "Mis avisos" (F4, Torre 757): la lista del cliente en Mi cuenta (pagina /pages/avisame), leida y cancelada contra
  // Argos. Pendientes con su casilla para quitar varios; lo avisado en los ultimos 30 dias, solo para consultar.
  function misAvisos(caja) {
    caja.textContent = '';
    if (!C.token) { caja.appendChild(el('p', 'ewd-av-nota', T.entra)); return; }
    caja.appendChild(el('p', 'ewd-av-nota', T.cargando));
    api('mis-avisos').then(function (j) {
      caja.textContent = '';
      caja.appendChild(el('h2', 'ewd-av-titulo', T.titulo));
      if (!j.avisos.length) { caja.appendChild(el('p', 'ewd-av-nota', T.vacio)); return; }
      var barra = el('div', 'ewd-av-barra');
      var todosL = el('label', 'ewd-av-todos');
      var todosC = document.createElement('input'); todosC.type = 'checkbox';
      todosL.appendChild(todosC); todosL.appendChild(document.createTextNode(' ' + T.todosSel));
      var quitarSel = el('button', 'ewd-av-quitar', T.quitarSel); quitarSel.type = 'button'; quitarSel.disabled = true;
      barra.appendChild(todosL); barra.appendChild(quitarSel);
      caja.appendChild(barra);
      var tabla = el('table', 'ewd-av-tabla');
      var thead = el('thead'); var trh = el('tr');
      ['', '', T.colProducto, 'SKU', T.colEstado, ''].forEach(function (x) { trh.appendChild(el('th', null, x)); });
      thead.appendChild(trh); tabla.appendChild(thead);
      var tbody = el('tbody'); tabla.appendChild(tbody);
      var casillas = [];
      var cola = Promise.resolve();
      function vacio() { if (!tbody.children.length) { barra.remove(); tabla.remove(); caja.appendChild(el('p', 'ewd-av-nota', T.vacio)); } }
      function marcar() { var n = casillas.filter(function (c) { return c.checked && c.isConnected; }).length; quitarSel.disabled = !n; }
      function quitar(a, tr, boton) {
        if (boton) boton.disabled = true;
        return api('quitar', { variante: a.variante }).then(function () {
          lista.delete(a.variante); tr.remove(); todos(); vacio(); marcar();
        }).catch(function (e) { if (boton) { boton.disabled = false; boton.textContent = e.status === 401 ? T.sesion : T.error; } });
      }
      j.avisos.forEach(function (a, i) {
        var tr = el('tr', 'ewd-av-fila');
        var tdC = el('td'); var tdI = el('td', 'ewd-av-img'); var tdN = el('td'); var tdS = el('td', 'ewd-av-sku', a.sku || '');
        var pend = a.estado === 'pendiente';
        if (pend) { var c = document.createElement('input'); c.type = 'checkbox'; c.addEventListener('change', marcar); c._aviso = a; c._fila = tr; casillas.push(c); tdC.appendChild(c); }
        var enlace = el('a', 'ewd-av-nombre', a.titulo || a.sku || a.variante); enlace.href = '/variants/' + a.variante; tdN.appendChild(enlace);
        var tdE = el('td', 'ewd-av-estado', pend ? T.pendiente : T.avisado + ' ' + (a.aviso ? new Date(a.aviso).toLocaleDateString(C.idioma || 'es') : ''));
        var tdQ = el('td');
        if (pend) { var b = el('button', 'ewd-av-quitar', T.quitar); b.type = 'button'; b.addEventListener('click', function () { quitar(a, tr, b); }); tdQ.appendChild(b); }
        [tdC, tdI, tdN, tdS, tdE, tdQ].forEach(function (x) { tr.appendChild(x); });
        tbody.appendChild(tr);
        if (i < 60) cola = cola.then(function () { return datosDe(a, enlace, tdI); });
      });
      todosC.addEventListener('change', function () { casillas.forEach(function (c) { if (c.isConnected) c.checked = todosC.checked; }); marcar(); });
      quitarSel.addEventListener('click', function () {
        quitarSel.disabled = true;
        var sel = casillas.filter(function (c) { return c.checked && c.isConnected; });
        sel.reduce(function (p, c) { return p.then(function () { return quitar(c._aviso, c._fila, null); }); }, Promise.resolve())
          .then(function () { todosC.checked = false; marcar(); });
      });
      caja.appendChild(tabla);
    }).catch(function (e) {
      caja.textContent = '';
      caja.appendChild(el('p', 'ewd-av-nota', e.status === 401 ? T.sesion : T.error));
    });
  }

  function estilosUnaVez() {
    if (document.getElementById('ewd-avisame-css')) return;
    var s = document.createElement('style');
    s.id = 'ewd-avisame-css';
    s.textContent = [
      'button.ewd-avisame-btn{display:inline-flex;align-items:center;gap:.4rem;padding:0;border:0;background:transparent;color:#f26b21;font:inherit;font-size:1rem;font-weight:500;line-height:1.4;cursor:pointer;margin-top:1rem}',
      '.upng-notify-me-spinner{width:.85em;height:.85em;border:2px solid currentColor;border-right-color:transparent;border-radius:999px;display:inline-block;opacity:0;animation:ewdAvGira .7s linear infinite}',
      '.is-loading .upng-notify-me-spinner{opacity:1}',
      '.avisame-btn-container.is-loading,.ewd-avisame-btn.is-loading{pointer-events:none;cursor:progress}',
      '@keyframes ewdAvGira{to{transform:rotate(360deg)}}',
      '.ewd-av-descatalogado{opacity:.85;color:#8a8a8a!important}',
      '.ewd-av-descatalogado[data-ewd-sustituto]{color:#1a5fb4!important;text-decoration:underline;cursor:pointer}',
      '.ewd-av-barra{display:flex;gap:1rem;align-items:center;justify-content:space-between;margin:1rem 0}',
      // El tema pone display:block y bordes a los td: aqui se fuerza una tabla de verdad (22/10, visto en DEV).
      '#ewd-mis-avisos .ewd-av-tabla{display:table!important;width:100%;border-collapse:collapse;font-size:.95em;table-layout:auto}',
      '#ewd-mis-avisos .ewd-av-tabla thead{display:table-header-group!important}',
      '#ewd-mis-avisos .ewd-av-tabla tbody{display:table-row-group!important}',
      '#ewd-mis-avisos .ewd-av-tabla tr{display:table-row!important}',
      '#ewd-mis-avisos .ewd-av-tabla th,#ewd-mis-avisos .ewd-av-tabla td{display:table-cell!important;width:auto!important;border:0!important;border-bottom:1px solid rgba(0,0,0,.1)!important;padding:.55rem .5rem!important;vertical-align:middle;text-align:left}',
      '#ewd-mis-avisos .ewd-av-tabla th{font-weight:500;opacity:.7;white-space:nowrap}',
      '.ewd-av-img img{width:60px;height:60px;object-fit:contain;display:block}',
      '.ewd-av-sku{white-space:nowrap;font-family:Consolas,monospace}',
      '@media (max-width:640px){#ewd-mis-avisos .ewd-av-tabla th:nth-child(2),#ewd-mis-avisos .ewd-av-tabla td:nth-child(2),#ewd-mis-avisos .ewd-av-tabla th:nth-child(4),#ewd-mis-avisos .ewd-av-tabla td:nth-child(4){display:none!important}}',
      '.ewd-av-lista{list-style:none;padding:0;margin:1rem 0}',
      '.ewd-av-fila{display:flex;flex-wrap:wrap;gap:.5rem 1rem;align-items:center;padding:.6rem 0;border-bottom:1px solid rgba(0,0,0,.1)}',
      '.ewd-av-nombre{flex:1 1 16rem;font-weight:500}',
      '.ewd-av-estado{opacity:.75;font-size:.9em}',
      '.ewd-av-quitar{background:none;border:1px solid currentColor;border-radius:4px;padding:.2rem .7rem;cursor:pointer;font:inherit;font-size:.9em;white-space:nowrap}'
    ].join('\n');
    document.head.appendChild(s);
  }

  // Pregunta por las variantes de la pagina que aun no se sabe si estan descatalogadas (sin token: es dato publico).
  function consultarEstado() {
    var ids = [];
    var bs = document.querySelectorAll(SEL);
    for (var i = 0; i < bs.length; i++) { var id = idDe(bs[i]); if (id && !preguntadas.has(id)) ids.push(id); }
    ((C.producto && C.producto.variantes) || []).forEach(function (v) { var s = String(v.id); if (!v.d && !preguntadas.has(s) && ids.indexOf(s) < 0) ids.push(s); });
    if (!ids.length || !C.tienda) return Promise.resolve();
    ids.forEach(function (x) { preguntadas.add(x); });
    return fetch(C.api + '/avisame/estado', {
      method: 'POST', headers: { 'content-type': 'application/json' }, credentials: 'omit',
      body: JSON.stringify({ tienda: C.tienda, variantes: ids.slice(0, 200) })
    }).then(function (r) { return r.ok ? r.json() : { descatalogadas: {} }; }).then(function (j) {
      var d = (j && j.descatalogadas) || {};
      Object.keys(d).forEach(function (k) { desc.set(k, d[k].sustituto || null); });
      if (Object.keys(d).length) todos();
    }).catch(function () { /* sin estado: Avisame normal */ });
  }

  var pendienteRefresco = null;
  function refrescar() {
    if (pendienteRefresco) return;
    pendienteRefresco = setTimeout(function () { pendienteRefresco = null; inyectar(); todos(); consultarEstado(); }, 120);
  }

  function arrancar() {
    if (upangoManda()) { if (window.console) console.info('[ewd-avisame] el bloque de Upango esta encendido: manda el suyo, el boton propio no hace nada'); return; }
    estilosUnaVez();
    window.ewdAvisame = { refrescar: refrescar, lista: lista, misAvisos: misAvisos };

    // Lo que el tema llama por su nombre de Upango: la tarjeta (anadir rapido) y el carrito ("avisame de lo agotado").
    window.upng_avisame_main = function () { refrescar(); setTimeout(refrescar, 600); setTimeout(refrescar, 1500); };
    window.upng_callAvisame = function (variante) {
      if (!C.token) return Promise.resolve(false);
      return api('activar', { variante: String(variante) }).then(function () { lista.add(String(variante)); todos(); return true; }, function () { return false; });
    };

    var caja = document.getElementById('ewd-mis-avisos');
    if (caja) misAvisos(caja);

    if (!C.token) {
      var s = document.createElement('style');
      s.textContent = '.avisame-btn-container{display:none!important}';
      document.head.appendChild(s);
      return;
    }
    document.addEventListener('click', alPulsar, true);
    api('lista').then(function (j) {
      j.variantes.forEach(function (v) { lista.add(String(v)); });
    }).catch(function (e) {
      if (window.console) console.warn('[ewd-avisame] no se ha podido leer la lista: ' + e.message);
    }).then(function () {
      cargada = true;
      inyectar();
      todos();
      consultarEstado();
    });

    new MutationObserver(function () { if (cargada) refrescar(); })
      .observe(document.body, { childList: true, subtree: true });
    var fc = formularioCompra(), inp = fc && fc.querySelector('[name="id"]');
    if (inp) inp.addEventListener('change', refrescar);
    document.addEventListener('on:variant:change', refrescar);
    document.addEventListener('change', refrescar);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
  else arrancar();
})();
